import Service, { inject as service } from '@ember/service';
import InAppMessageTemplate from 'cio/models/in-app-message-template';
import DS from 'ember-data';

const MODEL_NAME = 'in-app-message-template';

export default class InAppMessageTemplateService extends Service {
  @service store!: DS.Store;

  async loadAllMessageTemplates(): Promise<InAppMessageTemplate[]> {
    // unload all message templates to prevent keeping deleted ones or
    // templates from previous accessed workspaces.
    await this.store.unloadAll(MODEL_NAME);

    let messages = await this.store.findAll(MODEL_NAME);
    return messages.toArray();
  }

  async findMessageTemplate(id: string): Promise<InAppMessageTemplate | null> {
    let messageTemplate = this.store.peekRecord(MODEL_NAME, id);
    if (messageTemplate == null) {
      // maybe not found because models weren't loaded yet
      await this.loadAllMessageTemplates();
    }
    return this.store.peekRecord(MODEL_NAME, id);
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    'in-app-message-template': InAppMessageTemplateService;
  }
}
